import { graphqlClient } from '../../graphql/graphql'
import { CREATE_PLAN, UPDATE_PLAN, DELETE_PLAN } from '../../graphql/mutations/plan'
import { FETCH_PLANS, FETCH_USER_PLANS, FETCH_PLAN_DETAILS } from '../../graphql/queries/plan'
import Vue from 'vue'

/**
 * Función para crear un plan(afiliación).
 * @param {Object} plan Objecto del plan que será creado.
 */
export const createPlan = async ({ commit }, plan) => {
    let { data: { createPlan: { name } } } = await graphqlClient.mutate({
        mutation: CREATE_PLAN(plan)
    })
    return name
}

/**
 * Función para editar un plan(afiliación).
 * @param {Object} plan Objecto del plan que será editado.
 */
export const updatePlan = async ({ commit }, plan) => {
    let { data: { updatePlan: { name } } } = await graphqlClient.mutate({
        mutation: UPDATE_PLAN(plan)
    })
    return name
}

/**
 * Función para eliminar un plan(afiliación).
 * @param {String} id Identificador del plan que será creado.
 */
export const deletePlan = async ({ commit }, id) => {
    let response = await graphqlClient.mutate({
        mutation: DELETE_PLAN(id)
    })
}

/**
 * Función para obtener todos los planes y mostrarlo en la sección de afiliaciones.
 */
export const fetchPlans = async ({ commit }) => {
    let { data: { plans } } = await graphqlClient.query({
        query: FETCH_PLANS,
        fetchPolicy: 'network-only'
    })
    commit('setPlans', plans)
}

/**
 * Función para obtener todos los planes con la información de sus transacciones y afiliados correspondientes.
 */
export const fetchUserPlans = async ({ commit }) => {
    let { data: { myPlans } } = await graphqlClient.query({
        query: FETCH_USER_PLANS,
        fetchPolicy: 'network-only'
    })
    commit('setPlans', myPlans)
}

/**
 * Función para obtener el detalle del plan(afiliación) seleccionado
 * (ESTA FUNCIÓN SE USA CUANDO SE QUIERE EDITAR O VER EL DETALLE DEL PLAN).
 * @param {String} id Identificador del plan.
 */
export const fetchPlanDetails = async ({ commit }, id) => {
    let { data: { planById } } = await graphqlClient.query({
        query: FETCH_PLAN_DETAILS,
        variables: { id },
        fetchPolicy: 'no-cache'
    })
    commit('setCurrentPlan', planById)
    return planById
}
